import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;